import { render, staticRenderFns } from "./Compensation.vue?vue&type=template&id=797b1794&scoped=true&"
import script from "./Compensation.vue?vue&type=script&lang=js&"
export * from "./Compensation.vue?vue&type=script&lang=js&"
import style0 from "./Compensation.vue?vue&type=style&index=0&id=797b1794&lang=less&scoped=true&"
import style1 from "./Compensation.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b1794",
  null
  
)

export default component.exports